import type { Command } from '../../types/commands'
import { formatCommandOutput, formatHighlight, colorize } from '../colorScheme'
import { buildCreedBlock, buildTaxJarBlock } from '../data/valuesContent'
import { dividers } from '../asciiArt'

function buildAll(): string {
  return `
╔═══════════════════════════════════════════════════════════╗
║              ${formatHighlight('VALUES & PRINCIPLES')}                            ║
║              ${colorize('What I keep on the board', 'brightBlack')}                            ║
╚═══════════════════════════════════════════════════════════╝
${buildCreedBlock()}
${colorize(dividers.circuit, 'brightBlack')}
${buildTaxJarBlock()}
${colorize(dividers.wave, 'brightBlack')}

  >> ${formatHighlight('values creed')}   - The Automattic Creed
  >> ${formatHighlight('values taxjar')}  - The TaxJar Way
`
}

export const valuesCommand: Command = {
  name: 'values',
  description: 'Engineering values and principles',
  aliases: ['principles', 'creed', 'beliefs'],
  usage: 'values [creed|taxjar]',
  category: 'info',
  execute: (args) => {
    const sub = args[0]?.toLowerCase()

    let text: string
    if (!sub) {
      text = buildAll()
    } else if (sub === 'creed' || sub === 'automattic') {
      text = buildCreedBlock()
    } else if (sub === 'taxjar') {
      text = buildTaxJarBlock()
    } else {
      return [
        {
          type: 'error',
          content: `Unknown section: "${sub}". Try: creed, automattic, taxjar`,
        },
      ]
    }

    const formatted = formatCommandOutput(text, {
      highlightTech: false,
      highlightNumbers: false,
      highlightDates: false,
      highlightPaths: false,
      highlightUrls: true,
    })

    return [
      {
        type: 'info',
        content: (
          <div dangerouslySetInnerHTML={{ __html: formatted }} />
        ),
      },
    ]
  },
}
